function staticPageApiFactory(storefrontApiClient) {
  const staticPageApi = {
    getStaticPage(staticPageId, staticPageKey, params) {
      return storefrontApiClient.get(staticPageId ? `static-page/${staticPageId}` : `static/page/preview/${staticPageKey}`, {
        params,
      });
    },
  };

  return staticPageApi;
}

export default staticPageApiFactory;
